import { useState, useEffect } from 'react';
import api from 'axios';
import { GlobalSettings } from '../types/inventory';

interface UseSettingsReturn {
  settings: GlobalSettings;
  isLoading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export const useSettings = (): UseSettingsReturn => {
  const [settings, setSettings] = useState<GlobalSettings>({
    leadTime: 7,
    diasCoberturaAlvo: 21,
    calculationPeriodDays: null,
    excludeNoSalesNoStock: false,
    excludeNoSalesWithStock: false,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await api.get<{
        success: boolean;
        error?: string;
        data?: {
          lead_time: number;
          cobertura_alvo: number;
          calculation_period_days: number | null;
          exclude_no_sales_no_stock: boolean;
          exclude_no_sales_with_stock: boolean;
        };
      }>('/sellers/stock-intelligence/settings');

      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.error || 'N\u00e3o foi poss\u00edvel carregar as configura\u00e7\u00f5es do lojista.');
      }
      setSettings({
        leadTime: Number(response.data.data.lead_time),
        diasCoberturaAlvo: Number(response.data.data.cobertura_alvo),
        calculationPeriodDays: response.data.data.calculation_period_days == null
          ? null
          : Number(response.data.data.calculation_period_days),
        excludeNoSalesNoStock: Boolean(response.data.data.exclude_no_sales_no_stock),
        excludeNoSalesWithStock: Boolean(response.data.data.exclude_no_sales_with_stock),
      });
    } catch (requestError: any) {
      setError(requestError?.response?.data?.error || requestError?.message || 'N\u00e3o foi poss\u00edvel carregar as configura\u00e7\u00f5es do lojista.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, isLoading, error, reload: fetchSettings };
};
